import { render, staticRenderFns } from "./EnergyTab.vue?vue&type=template&id=0768caa2&scoped=true"
import script from "./EnergyTab.vue?vue&type=script&lang=ts"
export * from "./EnergyTab.vue?vue&type=script&lang=ts"
import style0 from "./EnergyTab.vue?vue&type=style&index=0&id=0768caa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0768caa2",
  null
  
)

export default component.exports